import {_, React, observer, useMemo} from '@api'
import {CatalogDataItem_Mapped, BuilderCard} from '@modules'
import { LibraryAssignConstraint, LibraryItemConfig, nav, useCatalog} from '@stores'
import {ListPreviewCard} from 'centric-ui-components'
import * as css from './NoAllowAssignLibraryItemConstraintViolationDialogContent.css'

export type ConstraintViolations = { constraint: LibraryAssignConstraint, item: any, nonMatching: Array<{ field: string, itemValue: any, assignToValue: any }> }
interface MyProps {
  library: LibraryItemConfig
  libraryItem: any
  catalogItem: any
  violations: Array<ConstraintViolations>
}

export const NoAllowAssignLibraryItemConstraintViolationDialogContent = observer(({library, libraryItem, catalogItem, violations}: MyProps) => {
  const catalog = useCatalog(),
    {strings} = catalog,
    cardFields = useMemo(() => _.uniq([catalog.dataMap.title, catalog.dataMap.subtitle1, ..._.flatMap(violations.map(v => v.nonMatching.map(v => v.field)))].filter(_.identity)).map(f => catalog._fieldByName[f]).filter(_.identity), [violations])
  //console.log(toJS({library, libraryItem, catalogItem, violations, cardFields}, {recurseEverything: true}))
  return (
    <div className={css.root}>
      <div className={css.assignToPanel}>
        <label>{_.capitalize(strings.cannotAssign)} {library.label ?? library.name}</label>
        <div className={css.row}>
          <CatalogDataItem_Mapped data={libraryItem} dataMap={catalog.dataMapForLibrary(library)}>
            <ListPreviewCard
              stores={catalog.stores}
              showImage
              avatar={_.toUpper(library.label ? library.label[0] : '?')}
              library={library}
              hideTooltips
              showTooltip={false}
              showHex/>
          </CatalogDataItem_Mapped>
        </div>
      </div>
      <div className={css.nonMatchingItemsPanel}>
        <div className={css.row}>
          {violations.map(({item}, i) =>
            <div className={css.cardWithTitle} key={i}>
              <label className={css.title}>{_.capitalize(strings.sibling)}</label>

              <a target='_blank' href={nav.urlForObject(item)}>
                <BuilderCard key={i} levelOfDetail={1} data={item} hideButtons disableSelection visibleCardFields={cardFields}/>
              </a>
            </div>)}
          {/*<Icon icon='not-equal-to'/>*/}
          <div className={css.cardWithTitle}>
            <label className={css.title}>{_.capitalize(strings.target)}</label>
            <a target='_blank' href={nav.urlForObject(catalogItem)}>
              <BuilderCard levelOfDetail={1} data={catalogItem} hideButtons disableSelection visibleCardFields={cardFields}/>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/stores/catalog/AssignUniqueLibraryItem/NoAllowAssignLibraryItemConstraintViolationDialogContent.tsx